import EventDTO from '../models/event';

type PrioritizedEvent = Pick<EventDTO, 'priority' | 'date'>;

// Orden compartido por el banner y la grilla de "Próximos eventos": los
// destacados con mayor `priority` van primero (sin valor → 0) y, a igual
// prioridad, gana el que ocurre antes. Un solo comparador evita que la
// grilla y el carrusel muestren los mismos eventos en distinto orden.
const compareEventsByPriority = (a: PrioritizedEvent, b: PrioritizedEvent): number => {
  const priorityDiff = (b.priority ?? 0) - (a.priority ?? 0);
  if (priorityDiff !== 0) {
    return priorityDiff;
  }
  return new Date(a.date).getTime() - new Date(b.date).getTime();
};

export default compareEventsByPriority;
